module.exports = __webpack_public_path__ + "assets/img/zoomin.49719a73.svg";